import type { FC, ReactNode } from "react";
import { useEffect } from "react";
import { PopupClickContainerStateless } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import {
    PopupElementWrapper,
    PopupWrapper,
    PopupTitle,
    PopupSubTitle,
    ButtonsWrapper,
    PopupContainer,
} from "./SubNavEducationBarProminentPopupStyles";
import { useEducationBarProminentContext } from "app/components/educationbar/useEducationBarProminentContext";
import { allTrackers } from "app/services/track/track";

interface ISubNavEducationBarProminentPopup {
    isPopupOpen: boolean;
    setIsPopupOpen: (isPopupOpen: boolean) => void;
    children: ReactNode;
}

export const SubNavEducationBarProminentPopup: FC<ISubNavEducationBarProminentPopup> = (props) => {
    const { children, isPopupOpen, setIsPopupOpen } = props;
    const popupConfig = {
        placement: "bottom",
        padding: 22,
        width: 239,
        cssClassContainer: "Popup-element-wrapper--dark-mode",
        closeDelay: 500,
        minHeight: 153,
        autoPlacement: false,
        enabled: true,
    };
    const translate = useTranslation();

    const { isMinimized, handleDismiss, isDismissed } = useEducationBarProminentContext();

    useEffect(() => {
        if (isMinimized && !isDismissed) {
            setIsPopupOpen(true);
        }
    }, [isMinimized, isDismissed]);

    const handleGotItClick = () => {
        allTrackers.dispatchTrackEvent("Button", "close", "Header/Education/close tooltip ");
        setIsPopupOpen(false);
        handleDismiss();
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };
    return (
        <PopupContainer>
            <PopupElementWrapper className={"EducationPopupWrapper"}>
                <PopupClickContainerStateless
                    config={popupConfig}
                    isOpen={isPopupOpen}
                    appendTo={".EducationPopupWrapper"}
                    onClose={handleClose}
                    content={() => {
                        return (
                            <PopupWrapper>
                                <PopupTitle>{translate("growth.education.bar_prominent.popup.title")}</PopupTitle>
                                <PopupSubTitle>
                                    {translate("growth.education.bar_prominent.popup.subtitle")}
                                </PopupSubTitle>
                                <ButtonsWrapper>
                                    <Button
                                        className="outlinedBtn"
                                        type={"outlined"}
                                        onClick={handleGotItClick}
                                    >
                                        {translate("growth.education.bar_prominent.popup.got_it")}
                                    </Button>
                                </ButtonsWrapper>
                            </PopupWrapper>
                        );
                    }}
                >
                    <div>{children}</div>
                </PopupClickContainerStateless>
            </PopupElementWrapper>
        </PopupContainer>
    );
};
